import React,{useEffect,useRef,useState,useCallback,memo} from 'react';
import Cookies from 'universal-cookie';
import '../styles/grid.scss';
import heart from '../image/icon/icon-heart.png';

const Item = memo((props) => {
  const { data } = props;
  const cookies = new Cookies();
  const bookmark = useRef();

  function getEarliestDate(dataArray){
    if(dataArray.length > 1){
      var earliest = null;
      var selected = null;
      dataArray.forEach(e => {
        var startDate = null;
        if(e[3] != ''){
          startDate = Date.parse(e[3]);
        }else if(e[5] != ''){
          startDate = Date.parse(e[5]);
        }
        if(startDate){
          if(earliest){
            if(earliest < startDate){
                earliest = startDate;
                selected = e;
            }
          }else{
            earliest = startDate;
            selected = e;
          }
        }
      });
      return selected ? selected : dataArray[0];
    }else{
      return dataArray[0];
    }
  }

  function renderDate(data){
    var item = getEarliestDate(data);
    var type;
    var start;
    var timeString = "";
    if(item[3]){
      type = '預留';
      start = item[3];
    }
    if(item[5]){
      type = '派發';
      start = item[5];
    }
    if(start){
      var parts = start.split('/');
      var day = parts[0];
      var month = parts[1];
      timeString = day + "/" + month;
    }
    return (
      <div className="date" >{timeString} {type}</div>
    );
  }

  function onBookmarkClick(e){
    var target = e.target.getAttribute("data-ig");
    var favList = cookies.get("bookmarked",newList);
    if(!favList){
        favList = [];
    }
    const index = favList.indexOf(target);
    var newList = [];
    if (index > -1) {
      newList = favList.filter(b => b !== target);
      bookmark.current.classList.remove("active");
    }else{
      newList = favList.concat([target]);
      bookmark.current.classList.add("active");
    }
    cookies.set("bookmarked",newList);
  };

  useEffect(() => {
    var bookmarks = cookies.get("bookmarked");
    if(bookmarks){
      const index = bookmarks.indexOf(data[0][7]);
      if(index > -1){
          bookmark.current.classList.add("active");
      }
    }
  },[]);

  function renderItem(){
    return (
      <div className="block" id={data[0][7]} key={data[0][7]} >
        <div className="content" dangerouslySetInnerHTML={{__html: [data[0][10]]}} />
        <div className="bookmark">
          { renderDate(data) }
          <div ref={bookmark} className="icon" style={{ backgroundImage : 'url('+ heart +')' }} data-ig={data[0][7]} onClick={onBookmarkClick}></div>
        </div>
      </div>
    );
  }

  return renderItem();
});

export default Item;
